import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

export default function RequireAdmin() {
  const auth = useAuth();
  const location = useLocation();

  if (auth?.isLoading) return null;

  if (!auth?.isAuthenticated) {
    auth?.signinRedirect({ state: { returnTo: location.pathname } });
    return null;
  }

  const groups = (auth.user?.profile?.['cognito:groups'] as string[] | string | undefined) || [];
  const groupList = Array.isArray(groups) ? groups : [groups];
  const isAdmin = groupList.includes('admin');

  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}